import React from 'react';
import { Navigate } from 'react-router';
import { useAuthHook } from '../../hooks/useAuth.hook';
import { Routes } from '../../types/enums/Routes.enum';
import { Loading } from '../Loading';
import { storage } from '../../utils/Const.utils';
import { StorageKeys } from '../../types/enums/Storage.enum';

interface PostLoginRolRouteProps {
    children: React.ReactNode;
}

/**
 * Componente que protege la ruta de selección de rol post-login.
 * Solo permite acceso a usuarios autenticados que aún no han completado la selección de rol.
 */
export const PostLoginRolRoute: React.FC<PostLoginRolRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuthHook();

    /* Mostrar loading mientras verifica autenticación */
    if (isLoading) {
        return (
            <Loading
                variant="linear"
                message="Verificando estado de sesión..."
                fullscreen
                showIcon
            />
        );
    }

    /* Si el usuario no está autenticado, redirigir al login */
    if (!isAuthenticated) {
        return (
            <Navigate
                to={Routes.LOGIN}
                replace
            />
        );
    }

    //TODO: Verificar si el usuario ya completó la selección de rol/perfil. este valor hay que 
    const hasCompletedRolSelection = storage.get(StorageKeys.PERFIL);
    
    /* 
        Si ya completó la selección de rol y está tratando de acceder a esta página,
        redirigir al dashboard
    */ 
    if (hasCompletedRolSelection) {
        return (
            <Navigate
                to={Routes.DEFAULT}
                replace
            />
        );
    }

    /* Si está autenticado pero no ha completado la selección de rol, mostrar el contenido */
    return <>{children}</>;
};

export default PostLoginRolRoute;